import { on, createReducer } from '@ngrx/store';
import {
  addToCompareSuccess,
  getInstitutionsInCompare,
  getInstitutionsInCompareSuccess,
  removeFromCompare
} from './compare.actions';
import { Institution } from 'src/generated/graphql';
import { InstitutionInCompare } from '../../models/institution-in-compare';
import { StoreState } from '../../enums/store-state';

export const compareFeatureKey = 'compareFeatureKey';

export interface CompareState {
  compareState: StoreState;
  institutions: Institution[];
  institutionsInCompare: InstitutionInCompare[];
}

export const initialState: CompareState = {
  compareState: StoreState.idle,
  institutions: [],
  institutionsInCompare: []
};

export const compareReducer = createReducer(
  initialState,

  on(addToCompareSuccess, (state, data) => ({
    ...state,
    institutions: [...state.institutions, data.institution]
  })),

  on(removeFromCompare, (state, data) => ({
    ...state,
    institutions: state.institutions.filter((item) => item.id !== data.institution.id)
  })),
  on(getInstitutionsInCompare, (state) => ({
    ...state,
    compareState: StoreState.inProgress
  })),
  on(getInstitutionsInCompareSuccess, (state, data) => ({
    ...state,
    institutionsInCompare: data.institutions,
    compareState: StoreState.success
  }))
);
